import api from "../apiConfig";
import paramsFactory from "../../utils/paramsFactory";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  total(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/sas-statistics/total?${p}`);
  },
  exportTotal(params) {
    const p = paramsFactory({ ...params, export: "excel" });
    return api.get(`/api/v1/sas-statistics/total?${p}`, {
      responseType: "blob",
    });
  },
  connections() {
    return api.get(`/api/v1/sas-statistics/connections`);
  },
};
